// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__4oRk-","info":"Note_info__nd6XD","note":"Note_note__2pxq_","actions":"Note_actions__3R4RD"};